import {Language} from "../../controllers/Language";
import {useEffect, useState} from "react";
import {InputText, InputTextTypes} from "../commond/fields/InputText";
import SpinnerWhite from "../../media/images/spinner-gray.svg";
import {Globals} from "../../controllers/Globals";
import {Alert} from "../commond/Alert";
import {cuppa, log} from "../../../cuppa/cuppa";
import {UserCtrl} from "../../controllers/UserCtrl";
import {Link} from "react-router-dom";
import {Utils} from "../../controllers/Utils";

export function ResetPassword(){
	const [form, setForm] = useState({password:'', confirm_password:'', code:cuppa.urlValue('code'), email: cuppa.base64Decode(cuppa.urlValue('ref')) });
	const [isCodeExpired, setIsCodeExpired] = useState();
	const [message, setMessage] = useState('');

	useEffect(()=>{
		verifyResetPasswordData().then();
	}, []);

	async function verifyResetPasswordData(){
		let ref = cuppa.base64Decode(cuppa.urlValue('ref'));
		let code = cuppa.urlValue('code');
		if(!ref && cuppa.urlValue('code')) return;
		let result = await UserCtrl.resetPassword({email:ref, code, verifyCodeOnly:true});
		if(!result?.data?.resetPassword?.id){
			setIsCodeExpired(true);
		}else{
			setIsCodeExpired(false);
		}
	}

	async function onSubmit(e){
		e.preventDefault(); e.stopPropagation();
		let validation = cuppa.validateFormObject(form, {password:{required:true, regExp:"^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$", message:"The password must be no less than 8 characters, with a number, a symbol, a lower and an upper case letter"}, confirm_password:{equalTo:"password", label:'', message: "You must enter the same password in both fields"}})
		if(!validation.valid){
			let message = `${validation.message}.`;
			if(validation.label) message.replace('field', cuppa.capitalize(validation.label))
			Globals.mainPortal.add("Alert", <Alert key={"Alert"} message={message} title={"Error"} />)
			return;
		}
		let result = await UserCtrl.resetPassword(form);
		if(!result?.data?.resetPassword?.id){
			Globals.mainPortal.add("Alert", <Alert key={"Alert"} message={Language.value("URL not valid or has expired")} />);
			return;
		}

		if(cuppa.boolean(cuppa.urlValue('mobileApp'))){
			setMessage(Language.value('resetPasswordMobileMsg'))
			return;
		}

		Globals.mainPortal.add("Alert", <Alert key={"Alert"} message={Language.value(`Password reset successfully.`)} callback={()=>{
			Utils.redirect("/");
		}} />);
	}

	return (
		<div>
			{cuppa.boolean(message) ? (
				<div className={'flex d-column j-center a-center p-x-30 p-y-30 t-center'}>
					{message}
				</div>
			) : isCodeExpired === false ? (
				<form onSubmit={onSubmit} style={{display:'flex', flexDirection:'column',  padding:30}}>
					<h1>{Language.value('Reset Password')}</h1>
					<label htmlFor={"password"} className="label1" style={{marginTop:10}}>{Language.value('Password')}</label>
					<input id={"password"} type={InputTextTypes.PASSWORD} defaultValue={form.password} className={"input1"}  onChange={e=>{setForm({...form, password:e.target.value})}} />
					<label htmlFor={"confirm_password"} className="label1" style={{marginTop:10}}>{Language.value('Confirm Password')}</label>
					<input id={"confirm_password"} type={InputTextTypes.PASSWORD} defaultValue={form.confirm_password} className={"input1"}  onChange={e=>{setForm({...form, confirm_password:e.target.value})}} />
					<button className={`button1`} style={{marginTop:15}}>
						<span>{Language.value('Reset')}</span>
					</button>
					{!cuppa.boolean(cuppa.urlValue('hideSignIn')) && (
						<div className={'flex j-center t-center m-t-10'}>
							<span className={'m-r-5'}>Known your password?</span>
							<Link to={"/"} className={'d-i-children color-progress btn-alpha'}>{Language.value('Sign In')}</Link>
						</div>
					)}
				</form>

			) : (isCodeExpired === true) ? (
				<div className={'flex d-column j-center a-center p-x-30 p-y-30 t-center'}>
					{Language.value('linkExpiredMsg')}
				</div>
			) : (
				<div className={'flex d-column j-center a-center p-x-30 p-y-30 t-center'} >
					<img src={SpinnerWhite} width={20} height={20} alt={"loading"} style={{marginRight:10}}/>
				</div>
			)}
		</div>
	)
}
